/** Top toast (#app-notice). */
import { getEl } from './dom.js';

var appNoticeTimer: ReturnType<typeof setTimeout> | null = null;

export function flashAppNotice(msg: string): void {
  var el = getEl('app-notice');
  if (!el) return;
  var noticeEl = el;
  noticeEl.textContent = String(msg || '');
  noticeEl.classList.add('app-notice-visible');
  if (appNoticeTimer) {
    try { clearTimeout(appNoticeTimer); } catch (_) {}
    appNoticeTimer = null;
  }
  appNoticeTimer = setTimeout(function () {
    noticeEl.classList.remove('app-notice-visible');
    appNoticeTimer = null;
  }, 2200);
}
